import { render, staticRenderFns } from "./questionAnalysis.vue?vue&type=template&id=53a1df73&scoped=true&"
import script from "./questionAnalysis.vue?vue&type=script&lang=js&"
export * from "./questionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./questionAnalysis.vue?vue&type=style&index=0&id=53a1df73&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a1df73",
  null
  
)

export default component.exports